import React, { useState, useEffect, useMemo, useRef } from "react";
import { connect } from "react-redux";
import { Table, Button, Modal, Badge, Form, Tabs, Tab } from "react-bootstrap";
import MessageModal from "../Pages/MessageModel";
import { Link } from 'react-router-dom'; 
import {
  getAllBusinessModels,
  createBusinessModel,
  updateBusinessModel,
  deleteBusinessModel
} from "../../actions/adminBusinessModelActions";
import {
  getAllAddonPackages,
  createAddonPackage,
  updateAddonPackage,
  deleteAddonPackage
} from "../../actions/addonPackageActions";
import {
  getAllDiscounts,
  createDiscount,
  updateDiscount,
  deleteDiscount
} from "../../actions/discountActions";
import { formatCurrency } from "../utils/currencyHelper";
// const formatCurrency = (amount) =>
//   new Intl.NumberFormat("en-IN", {
//     style: "currency",
//     currency: "INR",
//     maximumFractionDigits: 0,
//   }).format(amount || 0);

const formatDate = (dateStr) => {
  if (!dateStr) return "-";
  return new Date(dateStr).toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

const formatShortText = (str, length = 50) => {
  if (!str) return "-";
  return str.length > length ? str.substring(0, length) + "..." : str;
};

const AdminBusinessAndAddonPage = ({
  businessModels,
  addonPackages,
  discounts,
  loadingBusinessModels,
  loadingAddonPackages,
  loadingDiscounts,
  errorBusinessModels,
  errorAddonPackages,
  errorDiscounts,
  getAllBusinessModels,
  createBusinessModel,
  updateBusinessModel,
  getAllAddonPackages,
  createAddonPackage,
  updateAddonPackage,
  deleteBusinessModel,
  deleteAddonPackage,
  getAllDiscounts,
  createDiscount,
  updateDiscount,
  selectedCurrency,
  deleteDiscount,
}) => {
  const [activeTab, setActiveTab] = useState("businessModels");
  const [modal, setModal] = useState({ show: false, title: "", message: "", variant: "" });
  const [deletingBusinessId, setDeletingBusinessId] = useState(null);
  const [deletingAddonId, setDeletingAddonId] = useState(null);
  const [deletingDiscountId, setDeletingDiscountId] = useState(null);
  const isMounted = useRef(false);
console.log("discounts",discounts)
  useEffect(() => {
    isMounted.current = true;
    getAllBusinessModels();
    getAllAddonPackages();
    getAllDiscounts();

    return () => {
      isMounted.current = false;
    };
  }, [getAllBusinessModels, getAllAddonPackages, getAllDiscounts]);

  // Business Model States
  const [showBusinessModal, setShowBusinessModal] = useState(false);
  const [currentBusinessModel, setCurrentBusinessModel] = useState(null);
  const [businessForm, setBusinessForm] = useState({
    module_name: "",
    price: "",
    priceType: "Fixed",
    facilities: "",
    status: "active",
  });
  const [isBusinessSaving, setIsBusinessSaving] = useState(false);
  const [statusUpdatingBusinessId, setStatusUpdatingBusinessId] = useState(null);

  // Add-on Package States
  const [showAddonModal, setShowAddonModal] = useState(false);
  const [currentAddonPackage, setCurrentAddonPackage] = useState(null);
  const [addonForm, setAddonForm] = useState({
    package_name: "",
    price: "",
    description: "",
    status: "active",
  });
  const [isAddonSaving, setIsAddonSaving] = useState(false);
  const [statusUpdatingAddonId, setStatusUpdatingAddonId] = useState(null);

  // Discount States
  const [showDiscountModal, setShowDiscountModal] = useState(false);
  const [currentDiscount, setCurrentDiscount] = useState(null);
  const [discountForm, setDiscountForm] = useState({
    month: "",
    discount: "",
    status: "active",
  });
  const [isDiscountSaving, setIsDiscountSaving] = useState(false);
  const [statusUpdatingDiscountId, setStatusUpdatingDiscountId] = useState(null);

  // Filters
  const [businessFilters, setBusinessFilters] = useState({
    search: "",
    status: "All",
    sortBy: "module_name_asc",
  });

  const [addonFilters, setAddonFilters] = useState({
    search: "",
    status: "All",
    sortBy: "package_name_asc",
  });

  const [discountFilters, setDiscountFilters] = useState({
    status: "All",
    sortBy: "month_asc",
  });

  // Delete handlers
  const handleDeleteBusinessModel = async (model) => {
    if (!model?.id) {
      setModal({
        show: true,
        title: "Error",
        message: "Cannot delete an invalid business model.",
        variant: "danger",
      });
      return;
    }
    setDeletingBusinessId(model.id);
    try {
      await deleteBusinessModel(model.id);
      if (isMounted.current) {
        setModal({
          show: true,
          title: "Success",
          message: "Business Model deleted successfully!",
          variant: "success",
        });
        await getAllBusinessModels();
      }
    } catch (err) {
      if (isMounted.current) {
        setModal({
          show: true,
          title: "Error",
          message: `Failed to delete Business Model: ${err.message || err}`,
          variant: "danger",
        });
      }
    } finally {
      if (isMounted.current) {
        setDeletingBusinessId(null);
      }
    }
  };

  const handleDeleteAddonPackage = async (pkg) => {
    if (!pkg?.id) {
      setModal({
        show: true,
        title: "Error",
        message: "Cannot delete an invalid add-on package.",
        variant: "danger",
      });
      return;
    }
    setDeletingAddonId(pkg.id);
    try {
      await deleteAddonPackage(pkg.id);
      if (isMounted.current) {
        setModal({
          show: true,
          title: "Success",
          message: "Add-on Package deleted successfully!",
          variant: "success",
        });
        await getAllAddonPackages();
      }
    } catch (err) {
      if (isMounted.current) {
        setModal({
          show: true,
          title: "Error",
          message: `Failed to delete Add-on Package: ${err.message || err}`,
          variant: "danger",
        });
      }
    } finally {
      if (isMounted.current) {
        setDeletingAddonId(null);
      }
    }
  };

  const handleDeleteDiscount = async (discount) => {
    if (!discount?.id) {
      setModal({
        show: true,
        title: "Error",
        message: "Cannot delete an invalid discount.",
        variant: "danger",
      });
      return;
    }
    setDeletingDiscountId(discount.id);
    try {
      await deleteDiscount(discount.id);
      if (isMounted.current) {
        setModal({
          show: true,
          title: "Success",
          message: "Discount deleted successfully!",
          variant: "success",
        });
        await getAllDiscounts();
      }
    } catch (err) {
      if (isMounted.current) {
        setModal({
          show: true,
          title: "Error",
          message: `Failed to delete Discount: ${err.message || err}`,
          variant: "danger",
        });
      }
    } finally {
      if (isMounted.current) {
        setDeletingDiscountId(null);
      }
    }
  };

  // Business form handlers
  const handleBusinessFormChange = (e) => {
    setBusinessForm({ ...businessForm, [e.target.name]: e.target.value });
  };

  const handleOpenBusinessModal = (model = null) => {
    setCurrentBusinessModel(model);
    if (model) {
      setBusinessForm({
        module_name: model.module_name,
        price: model.price,
        priceType: model.priceType || "Fixed",
        facilities: model.facilities,
        status: model.status,
      });
    } else {
      setBusinessForm({
        module_name: "",
        price: "",
        priceType: "Fixed",
        facilities: "",
        status: "active",
      });
    }
    setShowBusinessModal(true);
  };

  const handleSaveBusinessModel = async (e) => {
    e.preventDefault();
    setIsBusinessSaving(true);
    try {
      if (currentBusinessModel) {
        await updateBusinessModel({ ...businessForm, id: currentBusinessModel.id });
        if (isMounted.current) {
          setModal({
            show: true,
            title: "Success",
            message: "Business Model updated successfully!",
            variant: "success",
          });
        }
      } else {
        await createBusinessModel(businessForm);
        if (isMounted.current) {
          setModal({
            show: true,
            title: "Success",
            message: "Business Model created successfully!",
            variant: "success",
          });
        }
      }
      if (isMounted.current) {
        setShowBusinessModal(false);
        setBusinessForm({ module_name: "", price: "", priceType: "Fixed", facilities: "", status: "active" });
      }
      setTimeout(() => {
        if (isMounted.current) {
          getAllBusinessModels();
        }
      }, 100);
    } catch (err) {
      if (isMounted.current) {
        setModal({
          show: true,
          title: "Error",
          message: `Failed to save Business Model: ${err.message || err}`,
          variant: "danger",
        });
      }
    } finally {
      if (isMounted.current) {
        setIsBusinessSaving(false);
      }
    }
  };

  const handleToggleBusinessStatus = async (model) => {
    const currentStatus = model?.status?.toLowerCase();
    const newStatus = currentStatus === "active" ? "inactive" : "active";
    if (!model?.id) {
      setModal({
        show: true,
        title: "Error",
        message: "Cannot update status for an invalid business model.",
        variant: "danger",
      });
      return;
    }
    setStatusUpdatingBusinessId(model.id);
    try {
      await updateBusinessModel({ id: model.id, status: newStatus });
      if (isMounted.current) {
        setModal({
          show: true,
          title: "Success",
          message: "Business Model status updated successfully!",
          variant: "success",
        });
        await getAllBusinessModels();
      }
    } catch (err) {
      if (isMounted.current) {
        setModal({
          show: true,
          title: "Error",
          message: `Failed to update status: ${err.message || err}`,
          variant: "danger",
        });
      }
    } finally {
      if (isMounted.current) {
        setStatusUpdatingBusinessId(null);
      }
    }
  };

  // Add-on package handlers
  const handleAddonFormChange = (e) => {
    setAddonForm({ ...addonForm, [e.target.name]: e.target.value });
  };

  const handleOpenAddonModal = (pkg = null) => {
    setCurrentAddonPackage(pkg);
    if (pkg) {
      setAddonForm({
        package_name: pkg.package_name,
        price: pkg.price,
        description: pkg.description,
        status: pkg.status,
      });
    } else {
      setAddonForm({
        package_name: "",
        price: "",
        description: "",
        status: "active",
      });
    }
    setShowAddonModal(true);
  };

  const handleSaveAddonPackage = async (e) => {
    e.preventDefault();
    setIsAddonSaving(true);
    try {
      if (currentAddonPackage) {
        await updateAddonPackage({ ...addonForm, id: currentAddonPackage.id });
        if (isMounted.current) {
          setModal({
            show: true,
            title: "Success",
            message: "Add-on Package updated successfully!",
            variant: "success",
          });
        }
      } else {
        await createAddonPackage(addonForm);
        if (isMounted.current) {
          setModal({
            show: true,
            title: "Success",
            message: "Add-on Package created successfully!",
            variant: "success",
          });
        }
      }
      if (isMounted.current) {
        setShowAddonModal(false);
        setAddonForm({ package_name: "", price: "", description: "", status: "active" });
        await getAllAddonPackages();
      }
    } catch (err) {
      if (isMounted.current) {
        setModal({
          show: true,
          title: "Error",
          message: `Failed to save Add-on Package: ${err.message || err}`,
          variant: "danger",
        });
      }
    } finally {
      if (isMounted.current) {
        setIsAddonSaving(false);
      }
    }
  };

  const handleToggleAddonStatus = async (pkg) => {
    const currentStatus = pkg?.status?.toLowerCase();
    const newStatus = currentStatus === "active" ? "inactive" : "active";
    setStatusUpdatingAddonId(pkg.id);
    try {
      await updateAddonPackage({ id: pkg.id, status: newStatus });
      if (isMounted.current) {
        setModal({
          show: true,
          title: "Success",
          message: "Add-on Package status updated successfully!",
          variant: "success",
        });
        await getAllAddonPackages();
      }
    } catch (err) {
      if (isMounted.current) {
        setModal({
          show: true,
          title: "Error",
          message: `Failed to update status: ${err.message || err}`,
          variant: "danger",
        });
      }
    } finally {
      if (isMounted.current) {
        setStatusUpdatingAddonId(null);
      }
    }
  };

  // Discount form handlers
  const handleDiscountFormChange = (e) => {
    setDiscountForm({ ...discountForm, [e.target.name]: e.target.value });
  };

  const handleOpenDiscountModal = (discount = null) => {
    setCurrentDiscount(discount);
    if (discount) {
      setDiscountForm({
        month: discount.month || "",
        discount: discount.discount || "",
        status: discount.status || "active",
      });
    } else {
      setDiscountForm({
        month: "",
        discount: "",
        status: "active",
      });
    }
    setShowDiscountModal(true);
  };

  const handleSaveDiscount = async (e) => {
    e.preventDefault();
    setIsDiscountSaving(true);
    try {
      if (currentDiscount) {
        await updateDiscount({ ...discountForm, id: currentDiscount.id });
        if (isMounted.current) {
          setModal({
            show: true,
            title: "Success",
            message: "Discount updated successfully!",
            variant: "success",
          });
        }
      } else {
        await createDiscount(discountForm);
        if (isMounted.current) {
          setModal({
            show: true,
            title: "Success",
            message: "Discount created successfully!",
            variant: "success",
          });
        }
      }
      if (isMounted.current) {
        setShowDiscountModal(false);
        setDiscountForm({ month: "", discount: "", status: "active" });
        await getAllDiscounts();
      }
    } catch (err) {
      if (isMounted.current) {
        setModal({
          show: true,
          title: "Error",
          message: `Failed to save Discount: ${err.message || err}`,
          variant: "danger",
        });
      }
    } finally {
      if (isMounted.current) {
        setIsDiscountSaving(false);
      }
    }
  };

  const handleToggleDiscountStatus = async (discount) => {
    const currentStatus = discount?.status?.toLowerCase();
    const newStatus = currentStatus === "active" ? "inactive" : "active";
    setStatusUpdatingDiscountId(discount.id);
    try {
      await updateDiscount({ id: discount.id, status: newStatus });
      if (isMounted.current) {
        setModal({
          show: true,
          title: "Success",
          message: "Discount status updated successfully!",
          variant: "success",
        });
        await getAllDiscounts();
      }
    } catch (err) {
      if (isMounted.current) {
        setModal({
          show: true,
          title: "Error",
          message: `Failed to update status: ${err.message || err}`,
          variant: "danger",
        });
      }
    } finally {
      if (isMounted.current) {
        setStatusUpdatingDiscountId(null);
      }
    }
  };

  // Filtered data
  const filteredBusinessModels = useMemo(() => {
    let filtered = [...(businessModels || [])].filter(Boolean);

    if (businessFilters.status !== "All") {
      filtered = filtered.filter((model) => model.status?.toLowerCase() === businessFilters.status);
    }
    if (businessFilters.search.trim() !== "") {
      const lowerSearch = businessFilters.search.toLowerCase();
      filtered = filtered.filter(
        (model) =>
          model.module_name?.toLowerCase().includes(lowerSearch) ||
          model.facilities?.toLowerCase().includes(lowerSearch)
      );
    }

    switch (businessFilters.sortBy) {
      case "module_name_asc":
        filtered.sort((a, b) => (a?.module_name || "").localeCompare(b?.module_name || ""));
        break;
      case "module_name_desc":
        filtered.sort((a, b) => (b?.module_name || "").localeCompare(a?.module_name || ""));
        break;
      case "price_asc":
        filtered.sort((a, b) => (a?.price || 0) - (b?.price || 0));
        break;
      case "price_desc":
        filtered.sort((a, b) => (b?.price || 0) - (a?.price || 0));
        break;
      default:
        break;
    }
    return filtered;
  }, [businessModels, businessFilters]);

  const filteredAddonPackages = useMemo(() => {
    let filtered = [...(addonPackages || [])].filter(Boolean);

    if (addonFilters.status !== "All") {
      filtered = filtered.filter((pkg) => pkg.status?.toLowerCase() === addonFilters.status);
    }
    if (addonFilters.search.trim() !== "") {
      const lowerSearch = addonFilters.search.toLowerCase();
      filtered = filtered.filter(
        (pkg) =>
          pkg.package_name?.toLowerCase().includes(lowerSearch) ||
          pkg.description?.toLowerCase().includes(lowerSearch)
      );
    }

    switch (addonFilters.sortBy) {
      case "package_name_asc":
        filtered.sort((a, b) => (a?.package_name || "").localeCompare(b?.package_name || ""));
        break;
      case "package_name_desc":
        filtered.sort((a, b) => (b?.package_name || "").localeCompare(a?.package_name || ""));
        break;
      case "price_asc":
        filtered.sort((a, b) => (a?.price || 0) - (b?.price || 0));
        break;
      case "price_desc":
        filtered.sort((a, b) => (b?.price || 0) - (a?.price || 0));
        break;
      default:
        break;
    }
    return filtered;
  }, [addonPackages, addonFilters]);

  const filteredDiscounts = useMemo(() => {
    let filtered = [...(discounts || [])].filter(Boolean);

    if (discountFilters.status !== "All") {
      filtered = filtered.filter((discount) => discount.status?.toLowerCase() === discountFilters.status);
    }

    // Fixed sorting logic to handle mixed data types
    switch (discountFilters.sortBy) {
      case "month_asc":
        filtered.sort((a, b) => {
          const monthA = a?.month?.toString() || "";
          const monthB = b?.month?.toString() || "";
          return monthA.localeCompare(monthB, undefined, { numeric: true });
        });
        break;
      case "month_desc":
        filtered.sort((a, b) => {
          const monthA = a?.month?.toString() || "";
          const monthB = b?.month?.toString() || "";
          return monthB.localeCompare(monthA, undefined, { numeric: true });
        });
        break;
      case "percentage_asc":
        filtered.sort((a, b) => (parseFloat(a?.discount) || 0) - (parseFloat(b?.discount) || 0));
        break;
      case "percentage_desc":
        filtered.sort((a, b) => (parseFloat(b?.discount) || 0) - (parseFloat(a?.discount) || 0));
        break;
      default:
        break;
    }
    return filtered;
  }, [discounts, discountFilters]);

  const commonLoading = loadingBusinessModels || loadingAddonPackages || loadingDiscounts;
  const commonError = errorBusinessModels || errorAddonPackages || errorDiscounts;

  return (
    <>
      <MessageModal {...modal} onClose={() => setModal({ ...modal, show: false })} />

      <div className="page-wrapper ml-0">
        
      <div className="content-container">

         <div className="page-header filter-bar rounded">
                          <div className="row align-items-center">
                            <div className="col">
                              <h4 className="page-title">Business Models & Add-ons</h4>
                              <ul className="breadcrumb">
                                <li className="breadcrumb-item">
                                  <Link to="/doctor/dashboard">Admin Dashboard</Link>
                                </li>
                                <li className="breadcrumb-item active">Business Models & Add-ons</li>
                              </ul>
                            </div>
                          </div>
                        </div>
<div className="card">
<div className="card-body">
        <Tabs
          id="admin-management-tabs"
          activeKey={activeTab}
          onSelect={(k) => setActiveTab(k)}
          className="mb-3"
        >
          {/* Business Models Tab */}
          <Tab eventKey="businessModels" className="ml-5" title="Business Models">
            <div className="d-flex gap-2 flex-wrap mb-3">
              <input
                type="text"
                className="form-control"
                placeholder="Search Model Name or Facilities"
                style={{ maxWidth: 300 }}
                value={businessFilters.search}
                onChange={(e) => setBusinessFilters((f) => ({ ...f, search: e.target.value }))}
              />
              <select
                className="form-select"
                style={{ maxWidth: 150 }}
                value={businessFilters.status}
                onChange={(e) => setBusinessFilters((f) => ({ ...f, status: e.target.value }))}
              >
                <option value="All">All Statuses</option>
                <option value="active">Active</option>
                <option value="inactive">Inactive</option>
              </select>
              <select
                className="form-select"
                style={{ maxWidth: 150 }}
                value={businessFilters.sortBy}
                onChange={(e) => setBusinessFilters((f) => ({ ...f, sortBy: e.target.value }))}
              >
                <option value="module_name_asc">Name Asc</option>
                <option value="module_name_desc">Name Desc</option>
                <option value="price_asc">Price Asc</option>
                <option value="price_desc">Price Desc</option>
              </select>
              <button className='btn btn-info rounded-pill' onClick={() => handleOpenBusinessModal()}>
                Add New Business Model
              </button>
            </div>

            {commonError && <div className="alert alert-danger">{commonError}</div>}

            {loadingBusinessModels ? (
              <div className="text-center my-5">
                <div className="spinner-border"></div>
              </div>
            ) : filteredBusinessModels.length === 0 ? (
              <div className="text-center my-5 text-muted">
                <i className="fas fa-cubes fa-3x mb-3"></i>
                <p>No business models found.</p>
              </div>
            ) : (
              <Table hover responsive className="align-middle">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Model Name</th>
                    <th>Price Type</th>
                    <th>Price / Percentage</th>
                    <th>Facilities</th>
                    <th>Status</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredBusinessModels.map((model, index) => (
                    <tr key={model?.id || `business-temp-${index}-${Math.random()}`}>
                      <td>{model?.id || "-"}</td>
                      <td>{model?.module_name || "N/A"}</td>
                      <td>{model?.priceType === "Percent" ? "Percent" : "Fixed"}</td>
                      <td>
                        {model?.priceType === "Percent"
                          ? `${model?.price || 0}%`
                          :  formatCurrency(model?.price, selectedCurrency)}
                      </td>
                      <td>{formatShortText(model?.facilities, 70)}</td>
                      <td>
                        <Badge bg={model?.status?.toLowerCase() === "active" ? "success" : "secondary"}>
                          {model?.status || "N/A"}
                        </Badge>
                      </td>
                      <td>
                        <div className="d-flex align-items-center gap-2">
                          <div className="">
                            <input
                              type="checkbox"
                              id={`business_toggle_${model?.id || `temp-${index}`}`}
                              className="check"
                              checked={model?.status?.toLowerCase() === "active"}
                              onChange={() => handleToggleBusinessStatus(model)}
                              disabled={statusUpdatingBusinessId === model?.id}
                            />
                            <label
                              htmlFor={`business_toggle_${model?.id || `temp-${index}`}`}
                              className="checktoggle"
                            ></label>
                          </div>
                          <button  className="i-btn-edit "variant="primary" size="sm" onClick={() => handleOpenBusinessModal(model)}>
                            
                          </button>
                          <button
                          className=" i-btn-delete"
                            variant="danger"
                            size="sm"
                            onClick={() => handleDeleteBusinessModel(model)}
                            disabled={deletingBusinessId === model?.id}
                          >
                            {deletingBusinessId === model?.id ? "Deleting..." : ""}
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            )}
          </Tab>

          {/* Add-on Packages Tab */}
          <Tab eventKey="addonPackages" className="ml-5" title="Add-on Packages">
            <div className="d-flex gap-2 flex-wrap mb-3">
              <input
                type="text"
                className="form-control"
                placeholder="Search Package Name or Description"
                style={{ maxWidth: 300 }}
                value={addonFilters.search}
                onChange={(e) => setAddonFilters((f) => ({ ...f, search: e.target.value }))}
              />
              <select
                className="form-select"
                style={{ maxWidth: 150 }}
                value={addonFilters.status}
                onChange={(e) => setAddonFilters((f) => ({ ...f, status: e.target.value }))}
              >
                <option value="All">All Statuses</option>
                <option value="active">Active</option>
                <option value="inactive">Inactive</option>
              </select>
              <select
                className="form-select"
                style={{ maxWidth: 150 }}
                value={addonFilters.sortBy}
                onChange={(e) => setAddonFilters((f) => ({ ...f, sortBy: e.target.value }))}
              >
                <option value="package_name_asc">Name Asc</option>
                <option value="package_name_desc">Name Desc</option>
                <option value="price_asc">Price Asc</option>
                <option value="price_desc">Price Desc</option>
              </select>
              <Button variant="info rounded-pill" onClick={() => handleOpenAddonModal()}>
                Add New Add-on Package
              </Button>
            </div>

            {commonError && <div className="alert alert-danger">{commonError}</div>}

            {loadingAddonPackages ? (
              <div className="text-center my-5">
                <div className="spinner-border"></div>
              </div>
            ) : filteredAddonPackages.length === 0 ? (
              <div className="text-center my-5 text-muted">
                <i className="fas fa-gift fa-3x mb-3"></i>
                <p>No add-on packages found.</p>
              </div>
            ) : (
              <Table hover responsive className="align-middle ">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Package Name</th>
                    <th>Price</th>
                    <th>Description</th>
                    <th>Status</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredAddonPackages.map((pkg) => (
                    <tr key={pkg?.id || `addon-temp-${Math.random()}`}>
                      <td>{pkg?.id || "-"}</td>
                      <td>{pkg?.package_name || "N/A"}</td>
                      <td>{formatCurrency(pkg?.price, selectedCurrency)}</td>
                      <td>{formatShortText(pkg?.description, 70)}</td>
                      <td>
                        <Badge bg={pkg?.status?.toLowerCase() === "active" ? "success" : "secondary"}>
                          {pkg?.status || "N/A"}
                        </Badge>
                      </td>
                      <td>
                        <div className="d-flex align-items-center gap-2">
                          <div >
                            <input
                              type="checkbox"
                              id={`addon_toggle_${pkg?.id || `temp-${Math.random()}`}`}
                              className="check"
                              checked={pkg?.status?.toLowerCase() === "active"}
                              onChange={() => handleToggleAddonStatus(pkg)}
                              disabled={statusUpdatingAddonId === pkg?.id}
                            />
                            <label htmlFor={`addon_toggle_${pkg?.id || `temp-${Math.random()}`}`} className="checktoggle"></label>
                          </div>
                          <button className=" i-btn-edit" variant="primary" size="sm" onClick={() => handleOpenAddonModal(pkg)}>
                            
                          </button>
                          <button
                          className="i-btn-delete"
                            variant="danger"
                            size="sm"
                            onClick={() => handleDeleteAddonPackage(pkg)}
                            disabled={deletingAddonId === pkg?.id}
                          >
                            {deletingAddonId === pkg?.id ? "Deleting..." : ""}
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            )}
          </Tab>

          {/* Discounts Tab - FIXED */}
          <Tab eventKey="discounts" className="ml-5" title="Discounts">
            <div className="d-flex gap-2 flex-wrap mb-3">
              <select
                className="form-select"
                style={{ maxWidth: 150 }}
                value={discountFilters.status}
                onChange={(e) => setDiscountFilters((f) => ({ ...f, status: e.target.value }))}
              >
                <option value="All">All Statuses</option>
                <option value="active">Active</option>
                <option value="inactive">Inactive</option>
              </select>
              <select
                className="form-select"
                style={{ maxWidth: 150 }}
                value={discountFilters.sortBy}
                onChange={(e) => setDiscountFilters((f) => ({ ...f, sortBy: e.target.value }))}
              >
                <option value="month_asc">Month Asc</option>
                <option value="month_desc">Month Desc</option>
                <option value="percentage_asc">Discount Asc</option>
                <option value="percentage_desc">Discount Desc</option>
              </select>
              <Button variant="info rounded-pill" onClick={() => handleOpenDiscountModal()}>
                Add New Discount
              </Button>
            </div>

            {commonError && <div className="alert alert-danger">{commonError}</div>}

            {loadingDiscounts ? (
              <div className="text-center my-5">
                <div className="spinner-border"></div>
              </div>
            ) : filteredDiscounts.length === 0 ? (
              <div className="text-center my-5 text-muted">
                <i className="fas fa-percentage fa-3x mb-3"></i>
                <p>No discounts found.</p>
              </div>
            ) : (
              <Table hover responsive className="align-middle">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Month</th>
                    <th>Discount Percentage</th>
                    <th>Status</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredDiscounts.map((discount, index) => (
                    <tr key={discount?.id || `discount-temp-${index}-${Math.random()}`}>
                      <td>{discount?.id || "-"}</td>
                      <td>{discount?.month || "0"}</td>
                      <td>{discount?.discount || "0"}%</td>
                      <td>
                        <Badge bg={discount?.status?.toLowerCase() === "active" ? "success" : "secondary"}>
                          {discount?.status || "N/A"}
                        </Badge>
                      </td>
                      <td>
                        <div className="d-flex align-items-center gap-2">
                          <div>
                            <input
                              type="checkbox"
                              id={`discount_toggle_${discount?.id || `temp-${index}`}`}
                              className="check"
                              checked={discount?.status?.toLowerCase() === "active"}
                              onChange={() => handleToggleDiscountStatus(discount)}
                              disabled={statusUpdatingDiscountId === discount?.id}
                            />
                            <label
                              htmlFor={`discount_toggle_${discount?.id || `temp-${index}`}`}
                              className="checktoggle"
                            ></label>
                          </div>
                          <button className="i-btn-edit" variant="primary" size="sm" onClick={() => handleOpenDiscountModal(discount)}>
                           
                          </button>
                          <button
                            className="i-btn-delete"
                            variant="danger"
                            size="sm"
                            onClick={() => handleDeleteDiscount(discount)}
                            disabled={deletingDiscountId === discount?.id}
                          >
                            {deletingDiscountId === discount?.id ? "Deleting..." : ""}
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            )}
          </Tab>
        </Tabs>


        {/* Business Model Add/Edit Modal */}
        <Modal show={showBusinessModal} onHide={() => setShowBusinessModal(false)} centered>
          <Modal.Header className='bg-info text-white ' closeButton closeVariant="white">
            <Modal.Title>{currentBusinessModel ? "Edit Business Model" : "Add New Business Model"}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form onSubmit={handleSaveBusinessModel}>
              <Form.Group className="mb-3">
                <Form.Label>Model Name</Form.Label>
                <Form.Control
                  type="text"
                  name="module_name"
                  value={businessForm.module_name}
                  onChange={handleBusinessFormChange}
                  required
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Price Type</Form.Label>
                <Form.Select name="priceType" value={businessForm.priceType} onChange={handleBusinessFormChange}>
                  <option value="Fixed">Fixed Price</option>
                  <option value="Percent">Percentage</option>
                </Form.Select>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>
                  {businessForm.priceType === "Percent" ? "Percentage (%)" : "Price (INR)"}
                </Form.Label>
                <Form.Control
                  type="number"
                  name="price"
                  value={businessForm.price}
                  onChange={handleBusinessFormChange}
                  min="0"
                  max={businessForm.priceType === "Percent" ? "100" : undefined}
                  step="any"
                  required
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Facilities</Form.Label>
                <Form.Control
                  as="textarea"
                  name="facilities"
                  rows={3}
                  value={businessForm.facilities}
                  onChange={handleBusinessFormChange}
                  placeholder="Comma-separated facilities (e.g., unlimited doctors, 24/7 support)"
                  required
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Status</Form.Label>
                <Form.Select name="status" value={businessForm.status} onChange={handleBusinessFormChange}>
                  <option value="active">Active</option>
                  <option value="inactive">Inactive</option>
                </Form.Select>
              </Form.Group>

              <Button type="submit" variant="success rounded-pill" disabled={isBusinessSaving}>
                {isBusinessSaving ? "Saving..." : "Save Business Model"}
              </Button>
            </Form>
          </Modal.Body>
        </Modal>

        {/* Add-on Package Add/Edit Modal */}
        <Modal show={showAddonModal} onHide={() => setShowAddonModal(false)} centered>
         <Modal.Header className='bg-info text-white ' closeButton closeVariant="white">
            <Modal.Title>{currentAddonPackage ? "Edit Add-on Package" : "Add New Add-on Package"}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form onSubmit={handleSaveAddonPackage}>
              <Form.Group className="mb-3">
                <Form.Label>Package Name</Form.Label>
                <Form.Control
                  type="text"
                  name="package_name"
                  value={addonForm.package_name}
                  onChange={handleAddonFormChange}
                  required
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Price</Form.Label>
                <Form.Control
                  type="number"
                  name="price"
                  value={addonForm.price}
                  onChange={handleAddonFormChange}
                  min="0"
                  required
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Description</Form.Label>
                <Form.Control
                  as="textarea"
                  name="description"
                  rows={3}
                  value={addonForm.description}
                  onChange={handleAddonFormChange}
                  placeholder="Describe the benefits of this add-on package"
                  required
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Status</Form.Label>
                <Form.Select name="status" value={addonForm.status} onChange={handleAddonFormChange}>
                  <option value="active">Active</option>
                  <option value="inactive">Inactive</option>
                </Form.Select>
              </Form.Group>
              <Button type="submit" variant="success rounded-pill" disabled={isAddonSaving}>
                {isAddonSaving ? "Saving..." : "Save Add-on Package"}
              </Button>
            </Form>
          </Modal.Body>
        </Modal>

        {/* Discount Add/Edit Modal */}
        <Modal show={showDiscountModal} onHide={() => setShowDiscountModal(false)} centered>
          <Modal.Header className='bg-info text-white ' closeButton closeVariant="white">
            <Modal.Title>{currentDiscount ? "Edit Discount" : "Add New Discount"}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form onSubmit={handleSaveDiscount}>
              <Form.Group className="mb-3">
                <Form.Label>Month</Form.Label>
                <Form.Control
                  type="text"
                  name="month"
                  value={discountForm.month}
                  onChange={handleDiscountFormChange}
                  placeholder="Enter month (e.g., 6 or 'Oct')"
                  required
                />
                <Form.Text className="text-muted">
                  Enter the month value (numeric or text)
                </Form.Text>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Discount Percentage</Form.Label>
                <Form.Control
                  type="number"
                  name="discount"
                  value={discountForm.discount}
                  onChange={handleDiscountFormChange}
                  min="0"
                  max="100"
                  step="0.1"
                  placeholder="Discount percentage (0-100)"
                  required
                />
                <Form.Text className="text-muted">
                  Enter the discount percentage (0-100%)
                </Form.Text>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Status</Form.Label>
                <Form.Select name="status" value={discountForm.status} onChange={handleDiscountFormChange}>
                  <option value="active">Active</option>
                  <option value="inactive">Inactive</option>
                </Form.Select>
              </Form.Group>

              <Button type="submit" variant="success rounded-pill" disabled={isDiscountSaving}>
                {isDiscountSaving ? "Saving..." : "Save Discount"}
              </Button>
            </Form>
          </Modal.Body>
        </Modal>
        </div>
        </div>
      </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    businessModels: state.businessModels?.businessModels || [],
    loadingBusinessModels: state.businessModels?.loading,
    errorBusinessModels: state.businessModels?.error,

    addonPackages: state.addonPackages?.addonPackages || [],
    loadingAddonPackages: state.addonPackages?.loading,
    errorAddonPackages: state.addonPackages?.error,

    discounts: state.discounts?.discounts || [],
     selectedCurrency: state.currencyReducer.selectedCurrency,
    errorDiscounts: state.discounts?.error,
  };
};

const mapDispatchToProps = {
  getAllBusinessModels,
  deleteAddonPackage,
  deleteBusinessModel,
  createBusinessModel,
  updateBusinessModel,
  getAllAddonPackages,
  createAddonPackage,
  updateAddonPackage,
  getAllDiscounts,
  createDiscount,
  updateDiscount,
  deleteDiscount,
};

export default connect(mapStateToProps, mapDispatchToProps)(AdminBusinessAndAddonPage);